import React, { ReactNode } from 'react';
import { ITableOptions, Row } from './BasicTable';

interface IRowTemplate {
  row: Row;
  i: number;
  options?: ITableOptions;
}
export const RowTemplate: React.FC<IRowTemplate> = ({ row, i, options }) => {
  const rowClick = React.useCallback(
    (row: Row) => {
      if (options?.allowExpand) {
        row.toggleRowExpanded();
      }
      if (options?.rowClick) {
        options.rowClick(row);
      }
    },
    [options?.allowExpand],
  );

  const render = ({ column }: any, row: Row) => column?.formatter?.({ value: row[column?.id], row }) || row[column?.id];

  return (
    <React.Fragment key={'row-' + i}>
      <tr
        {...row.getRowProps()}
        key={'row-' + i}
        className={`cursor-pointer ${row.original.isDisabled ? 'text-gray-350 ' : ''} ${
          options?.noBorders ? 'border-y-gray-150 border-y' : 'border-y-white border-y-4 border-r border-r-gray-100'
        }`}
        onClick={() => rowClick(row)}
      >
        <TableCells row={row} cells={row.cells} options={options} render={(cell) => cell.render('Cell')} />
      </tr>
      {row.isExpanded && options?.expandDataKey
        ? row.original[options.expandDataKey]?.map((subRow: Row, subI: number) => (
            <tr
              key={'srow-' + subI}
              className={`border-y-white border-y-4 border-r border-r-gray-100 cursor-pointer ps-4 ${
                subRow.isDisabled ? 'text-gray-350' : ''
              }`}
            >
              <TableCells
                row={subRow}
                cells={row.cells}
                options={{ ...options, firstTdClass: 'ms-3' }}
                render={render}
              />
            </tr>
          ))
        : null}
    </React.Fragment>
  );
};

interface ITableCells {
  cells: any[];
  row: Row;
  render: ({ _column }: any, _row: Row) => ReactNode;
  options?: ITableOptions;
}
export const TableCells: React.FC<ITableCells> = ({ cells, render, options, row }) =>
  cells.map((cell: any, i: number) => (
    <td {...cell.getCellProps()} key={`cell-${i}`}>
      <div
        className={`p-2 ${options?.noBorders ? '' : 'border-y border-gray-100' + (i === 0 ? ' border-l-8 ' : '')} ${
          i === 0 ? options?.firstTdClass || '' : ''
        } ${options?.cellClass || ''}`}
        style={{ borderLeftColor: cell.row.original.color || '' }}
      >
        {render(cell, row)}
      </div>
    </td>
  ));
